import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import fireErrorAnalytics, {
	isNetworkError,
} from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { UPSELL_PAGE_DISMISSED_PROPERTY_KEY } from '../../constants.tsx';

export const fetchHasDismissedProperty = async (atlassianAccountId: string | null) => {
	const meta = {
		id: 'fetchUpsellDismissedProperty',
		packageName: 'jiraCmdbUpsellPage',
	};

	if (atlassianAccountId === null) {
		const error = new Error('atlassianAccountId is null');
		fireErrorAnalytics({ error, meta });
		return false;
	}

	try {
		await getUserProperty(atlassianAccountId, UPSELL_PAGE_DISMISSED_PROPERTY_KEY);
		return true;
	} catch (error) {
		if (error instanceof Error && isNetworkError(error)) {
			// don't capture analytics for this error as this is expected when a user has dimissed
			return false;
		}
		fireErrorAnalytics({ error: error instanceof Error ? error : undefined, meta });
		return false;
	}
};
